import type { ComponentProps } from 'react';
import { RichTextEditorInternal } from './rich-text-editor-internal';

type P = Omit<ComponentProps<typeof RichTextEditorInternal>, 'editable'>;

const RichTextEditor = (properties: P) => <RichTextEditorInternal {...properties} />;

export default RichTextEditor;
